<template>
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M45.82 5.57l-26.68 38a1 1 0 0 1-.75.43h-.07a1 1 0 0 1-.73-.31L2.28 27.62a1 1 0 0 1 0-1.42 1 1 0 0 1 1.41 0L18.2 41.43l26-37a1 1 0 0 1 1.64 1.14z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCheck'
}
</script>
